import { makeApiCallWithImages } from "../apiRequest";

const BUG_REPORT_ENDPOINT =
  process.env.VUE_APP_BUG_REPORT_ENDPOINT || "BugReporting/CreateBugReport";

export default {
  actions: {
    async reportBug({ commit }, payload) {
      const url = BUG_REPORT_ENDPOINT;
      const response = await makeApiCallWithImages(url, "POST", payload);
      return response;
    },
  },
};

